import React from 'react';
import { SECONDS_LEFT_HIGHLIGHT } from '../utils/constants.utils';
import { ClockIcon } from './icons/ClockIcon';

interface CounterProps {
  counter:number
  limit: number;
  isRecording: boolean;
}

export const Counter = ({ counter, limit, isRecording }:CounterProps) => (
  <div className="myinterview-widget-counter myinterview-text--S">
    {isRecording
      ? <div className="myinterview-widget-counter__dot" />
      : <div className="myinterview-widget-counter__clock"><ClockIcon /></div>}
    <span className={`myinterview-widget-counter__timer ${isRecording && limit - counter < SECONDS_LEFT_HIGHLIGHT ? 'myinterview-widget-counter__timer--red' : ''}`}>
      {new Date((limit - counter) * 1000).toISOString().substring(14, 19)}
    </span>
  </div>
);
